import { IGetMapaConcretagemFiltroUseCase } from "../../../presentation/useCases/read/get_mapa_concretagem_filtro_use_case";
import { MapaConcretagemFiltro } from "../../models/mapa_concretagem_filtro";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetMapaConcretagemFiltroUseCase
 */

export class GetMapaConcretagemFiltroUseCase implements IGetMapaConcretagemFiltroUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getMapaConcretagemFiltro(): Promise<MapaConcretagemFiltro | null> {
    return await this.repository.getMapaConcretagemFiltro();
  }
}
